var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettings = function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.188 6.25a.937.937 0 0 1 .937-.937h2.188a.937.937 0 1 1 0 1.875H3.125a.937.937 0 0 1-.937-.938m14.687 6.563h-2.5v-.938a.938.938 0 0 0-1.875 0v3.75a.938.938 0 0 0 1.875 0v-.937h2.5a.938.938 0 0 0 0-1.876m-6.562 0H3.125a.938.938 0 0 0 0 1.874h7.188a.938.938 0 0 0 0-1.874m-1.876-3.75a.937.937 0 0 0 .938-.938v-.937h7.5a.937.937 0 0 0 0-1.875h-7.5v-.938a.937.937 0 1 0-1.875 0v3.75a.937.937 0 0 0 .938.938"
  })));
};
export default SvgSettings;